
const getColumns = () => {
  const initSortObj = JSON.parse(sessionStorage.getItem('supervision_sorter'))
  const percentOrder = !initSortObj ? null : initSortObj.field === 'percent' ? initSortObj.order : null
  const answerNumOrder = !initSortObj ? null : initSortObj.field === 'answerNum' ? initSortObj.order : null
  const interactedNumOrder = !initSortObj ? null : initSortObj.field === 'interactedNum' ? initSortObj.order : null
  return [
    {
      title: '学员',
      dataIndex: 'studentName',
      fixed: 'left',
      width: 160,
      scopedSlots: { customRender: 'studentName' }
    },
    {
      title: '讲次信息',
      dataIndex: 'lessonTag',
      width: '10.6%',
      scopedSlots: { customRender: 'lessonTag' }
    },
    {
      title: '答题正确率',
      dataIndex: 'percent',
      align: 'center',
      sorter: (a, b) => a.answerRate - b.answerRate,
      defaultSortOrder: percentOrder,
      width: '11%',
      scopedSlots: { customRender: 'percent' }
    },
    {
      title: '答题次数',
      dataIndex: 'answerNum',
      sorter: (a, b) => a.answerNum - b.answerNum,
      defaultSortOrder: answerNumOrder,
      width: '11%',
      scopedSlots: { customRender: 'answerNum' }
    },
    {
      title: '当前行为',
      dataIndex: 'currentBehavior',
      width: '15%',
      scopedSlots: { customRender: 'currentBehavior' }
    },
    {
      title: '学习进度',
      dataIndex: 'studyProgress',
      // width: '48%',
      width: '58%',
      scopedSlots: { customRender: 'studyProgress' }
    },
    {
      title: '互动次数',
      dataIndex: 'interactedNum',
      sorter: (a, b) => a.interactedNum - b.interactedNum,
      defaultSortOrder: interactedNumOrder,
      width: '11%',
      scopedSlots: { customRender: 'interactedNum' }
    },
    {
      dataIndex: 'voiceInteractedNum',
      slots: { title: 'customTitle' },
      width: 132,
      // width: '11%',
      scopedSlots: { customRender: 'voiceInteractedNum' }
    }
  ]
}

export {
  getColumns
}